import React, { useState, useEffect, createContext } from "react";
import { MemoizedDetail } from "./Detail";
import ContractorBillingService from "../../services/ContractorBillingService";
import { MessageAlert } from "../../components/Components";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ConvertInputDateToISOFormatDateTimeString } from "../../utils/DateUtil";

const formDataContext = createContext();

const BillingSummaryReport = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const contractorBillingService = ContractorBillingService();

  const [isLoading, setIsLoading] = useState(false);
  const [isFetch, setIsFetch] = useState(false);
  const [isOpenTable, setIsOpenTable] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [isClickSearch, setIsClickSearch] = useState(false);
  const [pageCount, setPageCount] = useState(Math.ceil(totalRecordCount / pageSize));
  const [billingTypeList, setBillingTypeList] = useState([]);
  const [billingStatusList, setBillingStatusList] = useState([]);

  const initialListHistoryBillingRq = {
    deliveryStart: null,
    deliveryEnd: null,
    subno: null,
    billingStatus: null,
    billingType: null,
    billingTypeStatus: null,
    lotno: null,
    advno: null,
    startRow: null,
    pageSize: null,
  };
  const [listHistoryBillingRq, setListHistoryBillingRq] = useState(null);
  const [listHistoryBillingRs, setListHistoryBillingRs] = useState(null);

  const [selectedSubNo, setSelectedSubNo] = useState(null);

  const SetPageChange = async () => {
    setListHistoryBillingRq((prev) => ({
      ...prev,
      subno: selectedSubNo,
      pageSize: pageSize,
      startRow: (page - 1) * pageSize,
    }));
  };

  const GetConfig = async (paramType) => {
    try {
      setIsLoading(true);
      const response = await contractorBillingService.GetConfig({
        paramType: paramType,
      });
      setIsLoading(false);
      if (!response?.isSuccess)
        throw `${response.statusCode} - ${response.statusMessage}`;
      return response?.result?.configList;
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching details:", error);
    }
  };

  const GetConfigToTypeListANDStatusList = async () => {
    var typeList = await GetConfig("BILL_TYPE");
    setBillingTypeList(typeList);
    var statusList = await GetConfig("BILL_STATUS");
    setBillingStatusList(statusList);
  };

  const ListHistoryBilling = async (rq) => {
    try {
      setIsClickSearch(false);
      setIsLoading(true);
      setIsOpenTable(false);

      if (
        rq?.deliveryStart == null ||
        rq?.deliveryStart == "" ||
        rq?.deliveryEnd == null ||
        rq?.deliveryEnd == ""
      ) {
        throw `${t("PleaseSpecifyDate")}`;
      }

      const response = await contractorBillingService.ListHistoryBilling(rq);

      setIsLoading(false);

      if (!response?.isSuccess)
        throw `${response.statusMessage}`;
      setTotalRecordCount(response?.result?.totalRecord);
      setPageCount(Math.ceil(response?.result?.totalRecord / pageSize));
      setListHistoryBillingRs(response?.result?.billingHistory);
      setIsOpenTable(true);
    } catch (error) {
      setIsLoading(false);
      MessageAlert.error({ message: error });
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsOpenTable(false);
    setIsClickSearch(false);
    setPage(1);
    setPageSize(5);
    setTotalRecordCount(0);
    setListHistoryBillingRq(null);
    setListHistoryBillingRs(null);
    setIsLoading(false);
  };

  function ListenerSubNoWhenUpdate() {
    let subNoData = JSON.parse(localStorage.getItem("subNoData"))?.value;
    setIsFetch(false);
    if (subNoData != selectedSubNo) {
      setSelectedSubNo(subNoData);
      fetchData();
      setIsFetch(true);
    }
  }

  useEffect(() => {
    let subNoData = JSON.parse(localStorage.getItem("subNoData"))?.value;
    setSelectedSubNo(subNoData);
    window.addEventListener("storage", ListenerSubNoWhenUpdate);
    GetConfigToTypeListANDStatusList();

    return () => {};
  }, []);

  useEffect(() => {
    if (listHistoryBillingRq != null && isClickSearch) {
      ListHistoryBilling(listHistoryBillingRq);
      return () => {};
    }
  }, [listHistoryBillingRq]);

  useEffect(() => {
    if (isClickSearch) {
      SetPageChange();
    }
  }, [page, pageSize, isClickSearch]);

  return (
    <>
      <formDataContext.Provider
        value={{
          page,
          setPage,
          pageSize,
          setPageSize,
          totalRecordCount,
          setTotalRecordCount,
          isClickSearch,
          setIsClickSearch,
          pageCount,
          listHistoryBillingRs,
          setListHistoryBillingRs,
          isOpenTable,
          setIsOpenTable,
          billingTypeList,
          billingStatusList,
          listHistoryBillingRq,
          setListHistoryBillingRq,
          billingStatusList,
          billingTypeList,
          isFetch,setIsFetch,
        }}
      >
        <MemoizedDetail isLoading={isLoading} isOpenTable={isOpenTable} />
      </formDataContext.Provider>
    </>
  );
};

export { formDataContext };
export default BillingSummaryReport;
